import { PropsWithChildren, ReactNode } from "react";

interface Props extends PropsWithChildren {
  when: boolean;
  fallback?: ReactNode;
}

export const Show = ({ when, fallback, children }: Props) => {
  if (!when) return fallback;
  return children;
};
